import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';

import { store } from './helpers';
import { App } from './core';

import 'moment-duration-format';
import 'semantic-ui-less/semantic.less';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';

moment.locale('pt-br');
moment.tz.setDefault('America/Sao_Paulo');

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
});

render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('app'),
);
